"use client";

import GlobalErrorBoundary from "@faire/retailer-visitor-shared/GlobalErrorBoundary";

export default GlobalErrorBoundary;
